export default "__VITE_ASSET__uG$NSXoc__"